import { AfterContentInit, ChangeDetectorRef, Directive, ElementRef, Input } from "@angular/core";

@Directive({
    selector: "[pgh-autofocus]"
})
export class AutofocusDirective implements AfterContentInit {
    private focus = true;

    @Input() inputId: string = '';
    @Input() set autofocus(condition: boolean) {
        this.focus = condition !== false;
    }

    constructor(private el: ElementRef, private cdr: ChangeDetectorRef) { }

    ngAfterContentInit() {
        if (this.focus) {
            //The setTimeout is to avoid angular error: Expression has changed after it was checked.
            window.setTimeout(() => {
                this.cdr.detectChanges();
                if (this.inputId) {
                    const id = '#'+this.inputId;
                    this.el.nativeElement.querySelector(id).focus();
                } else {
                    this.el.nativeElement.focus();
                }
            });
        }        
    }
}